
window.__VUE_OPTIONS_API__ = true;

window.__VUE_PROD_DEVTOOLS__ = false;

window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;

import { createApp } from 'vue';

import { createRouter, createWebHashHistory } from 'vue-router';

import App from './components/app/index.vue';

import Report from './components/views/report.vue';

import Entry from './components/views/entry.vue';

import Form from './components/views/form.vue';

import Download from './components/views/download.vue';

function removeQueryParams( to ) {

  if ( Object.keys( to.query ).length )

    return { path: to.path, query: {}, hash: to.hash };

}

const routes = [ {

  name: 'home',

  path: '/',

  redirect: () => ( { path: '/entry' } )

}, {

  name: 'entry',

  path: '/entry',

  component: Entry,

  beforeEnter: [ removeQueryParams ]

}, {

  name: 'report',

  path: '/report',

  component: Report,

} , {

  name: 'form',

  path: '/form',

  component: Form,

}, {

  name: 'download',

  path: '/download',

  component: Download,

} ];

const router = createRouter( {

  history: createWebHashHistory(),

  scrollBehavior( to, from, savedPosition ) {

    if ( savedPosition ) {

      return savedPosition

    } else {

      return { left: 0, top: 0 }

    }
    
  },

  routes

} );

router.afterEach( ( to, from ) => {

  if ( typeof Munchkin == 'object' )

    Munchkin.munchkinFunction( 'visitWebPage', {
    
      'url': `/clin_us_2025_population-health-tool${ window.location.search }#${ to.fullPath }`

    } );

} );

router.beforeEach( ( to ) => {

  if ( ( to.name === 'form' || to.name === 'download' ) && to.query[ 'zip-code' ].length !== 5 ) {

    return { name: 'report', query: { 'zip-code': to.query[ 'zip-code' ] } }

  }

} );

const app = createApp( App );

app.use( router );

app.mount( '#app' );
